<template>
  <div>
    <v-layout id="landing-section" row :class="cityClassAcronym">
      <v-layout align-center justify-center>
        <v-flex xs12>
          <v-card color="transparent" flat>
            <v-card-text>
              <h3 id="slogan" class="text-xs-center white--text text-shadow">
                {{ $t('site.section1.slogan') }}
              </h3>
              <v-layout class="justify-center">
                <v-flex class="xs12 md6 text-xs-center">
                  <v-btn
                    color="accent"
                    large
                    round
                    :to="{ path: $t('urlParkingPage') }"
                    class="white--text initialize font-weight-bold mt-4"
                    v-html="$t('site.menu.seeParking')"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <div id="landing-section-bottom">
        <download-app />
        <v-layout
          id="download-app"
          class="justify-center white--text text-xs-center accent text-shadow"
        >
          <h2>
            {{ $t('site.section1.gift.noGift') }}
          </h2>
        </v-layout>
      </div>
    </v-layout>

    <template>
      <div v-waypoint="{ active: true, callback: onWaypoint }" />
    </template>

    <v-layout id="step-section" row wrap justify-center>
      <v-flex xs12 sm4 md2>
        <v-card
          flat
          color="transparent"
          class="white--text"
          :class="{
            'pt-3 pt-5': $vuetify.breakpoint.xsOnly,
            'mt-5 ml-5 mr-2 mb-2': $vuetify.breakpoint.smOnly,
            'py-5': $vuetify.breakpoint.mdAndUp
          }"
        >
          <v-responsive style="text-align: center">
            <v-avatar size="100px">
              <img src="/image/public/step-download.png" />
            </v-avatar>
          </v-responsive>
          <v-card-text
            class="text-xs-center"
            :class="{ 'px-5': $vuetify.breakpoint.xsOnly }"
          >
            {{ $t('site.section1.point1.noGift') }}
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm4 md2>
        <v-card
          flat
          color="transparent"
          class="white--text"
          :class="{
            'pt-3 pt-5': $vuetify.breakpoint.xsOnly,
            'mt-5 ml-5 mr-2 mb-2': $vuetify.breakpoint.smOnly,
            'py-5': $vuetify.breakpoint.mdAndUp
          }"
        >
          <v-responsive style="text-align: center">
            <v-avatar size="100px">
              <img src="/image/public/step-parking.png" />
            </v-avatar>
          </v-responsive>
          <v-card-text
            class="text-xs-center"
            :class="{ 'px-5': $vuetify.breakpoint.xsOnly }"
          >
            {{ $t('site.section1.point3') }}
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm4 md2>
        <v-card
          flat
          color="transparent"
          class="white--text"
          :class="{
            'pt-3 pt-5': $vuetify.breakpoint.xsOnly,
            'mt-5 ml-5 mr-2 mb-2': $vuetify.breakpoint.smOnly,
            'py-5': $vuetify.breakpoint.mdAndUp
          }"
        >
          <v-responsive style="text-align: center">
            <v-avatar size="100px">
              <img src="/image/public/step-creditcard.png" />
            </v-avatar>
          </v-responsive>
          <v-card-text
            class="text-xs-center"
            :class="{ 'px-5': $vuetify.breakpoint.xsOnly }"
          >
            {{ $t('site.section1.point4') }}
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout id="section-description" justify-center row class="pa-5">
      <v-flex xs12>
        <v-flex xs12 sm6>
          <img :src="priceImage" width="100%" />
        </v-flex>

        <v-flex xs12>
          <v-list
            class="pt-5 n-lines"
            :class="{ 'pr-3': $vuetify.breakpoint.smAndUp }"
          >
            <v-list-tile class="mb-4">
              <v-list-tile-sub-title
                v-html="
                  $t('site.section2.point1', {
                    parkings: countParkings,
                    city: city,
                    spots: 200
                  })
                "
              />
            </v-list-tile>
            <v-list-tile class="mb-4">
              <v-list-tile-sub-title v-html="$t('site.section2.point2')" />
            </v-list-tile>
            <v-list-tile class="mb-4">
              <v-list-tile-sub-title v-html="$t('site.section2.point3')" />
            </v-list-tile>
            <v-list-tile class="mb-4">
              <v-list-tile-sub-title v-html="$t('site.section2.point4')" />
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-flex>

      <v-flex sm5>
        <v-img :src="phoneImage" height="100%" contain />
      </v-flex>
    </v-layout>

    <v-layout id="section-review" row wrap class="pt-4">
      <v-flex xs12>
        <h1
          class="text-xs-center primary--text px-2 font-weight-bold"
          v-html="$t('site.section3.point1', { number: countUsers })"
        />
      </v-flex>

      <v-flex xs12 class="my-4">
        <v-carousel
          id="home"
          hide-delimiters
          cycle
          light
          height="auto"
          prev-icon="arrow_back_ios"
          next-icon="arrow_forward_ios"
        >
          <template v-for="(user, index) in users">
            <v-carousel-item :key="index">
              <v-card flat class="px-3">
                <v-card-title
                  justify-center
                  class="headline pt-0 font-italic"
                  v-html="user.message"
                ></v-card-title>
                <v-card-text
                  class="text-xs-center pt-0 title"
                  v-html="user.name"
                ></v-card-text>
              </v-card>
            </v-carousel-item>
          </template>
        </v-carousel>
      </v-flex>
    </v-layout>

    <v-layout id="section-video" row>
      <v-layout justify-center class="pb-5 pt-3">
        <v-flex xs11 sm10 md8>
          <v-card class="transparent pt-3" flat>
            <v-card-title class="white--text pa-0">
              <h1
                class="mx-auto text-xs-center display-1 font-weight-bold"
                v-html="$t('site.section4.title')"
              />
            </v-card-title>

            <v-card-text class="mt-4">
              <div class="video-container">
                <iframe
                  :src="video"
                  frameborder="0"
                  allow="autoplay;encrypted-media"
                  allowfullscreen
                />
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>

    <div class="contact white--text">
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex sm10 class="mx-auto" text-center>
            <!-- <v-card style="background-color: #5ea4c863"> -->
            <!-- <v-card style="background-color: #da95007d"> -->
            <v-card style="background-color: #88c1df7a">
              <v-card-title>
                <h1
                  class="mx-auto white--text text-xs-center display-1 font-weight-bold"
                  v-html="$t('site.section5.title')"
                />
              </v-card-title>

              <v-card-actions class="pa-0">
                <v-btn
                  color="secondary"
                  target="_blank"
                  class="font-weight-bold initialize title"
                  block
                  :href="typeform"
                  v-html="$t('site.section5.button')"
                />
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <v-container grid-list-md class="py-5">
      <h1
        class="primary--text text-xs-center display-1 font-weight-bold mb-2"
        v-html="$t('site.section6.title')"
      />
      <v-layout row wrap justify-center>
        <template v-for="media in medias">
          <v-flex :key="media.name" xs8 sm3 md3 class="text-center">
            <v-card class="grey lighten-4" :href="media.link" target="_blank">
              <v-card-text class="title pa-3">
                <v-img
                  :src="`/image/public/media/${media.image}.png`"
                  contain
                  height="80px"
                />
              </v-card-text>
            </v-card>
          </v-flex>
        </template>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import DownloadApp from '@/components/commons/DownloadApp';
import store from '@/store';
import _ from 'lodash';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import utilService from '@/services/utilService';

const configFile = require(process.env.VUE_APP_CONFIG);
const config = configFile.config;

export default {
  name: 'HomePage',
  components: {
    [DownloadApp.name]: DownloadApp
  },
  data() {
    return {};
  },
  computed: {
    cityClassAcronym: function () {
      return `${_.toLower(store.state.citySelected.code)}-background-image`;
    },
    priceImage() {
      return `/image/public/price/${store.state.citySelected.code.toLowerCase()}_${store.state.langSelected.lang.toLowerCase()}.png`;
      // if (store.state.countrySelected.code === 'ES') {
      //   return `/image/public/price/${store.state.citySelected.code.toLowerCase()}_${store.state.langSelected.lang.toLowerCase()}.png`;
      // } else {
      //   return `/image/public/price/${store.state.citySelected.code.toLowerCase()}.png`;
      // }
    },
    phoneImage() {
      return `/image/public/phone-${store.state.citySelected.code.toLowerCase()}.png`;
    },
    medias() {
      return config.SITE[store.state.countrySelected.code].MEDIA;
    },
    typeform() {
      return config.SITE[store.state.countrySelected.code].TYPEFORM;
    },
    users() {
      return config.SITE[store.state.countrySelected.code].USERS;
    },
    video() {
      return config.SITE[store.state.countrySelected.code].VIDEO;
    },
    countParkings() {
      // eslint-disable-next-line standard/computed-property-even-spacing
      return config.SITE[store.state.countrySelected.code].MKT[
        store.state.citySelected.code
      ].PARKINGS;
    },
    countUsers() {
      // eslint-disable-next-line standard/computed-property-even-spacing
      return config.SITE[store.state.countrySelected.code].MKT[
        store.state.citySelected.code
      ].USERS;
    },
    city() {
      return store.state.citySelected.name;
    },
    twitterHashtag() {
      return store.state.countrySelected.twitterHashtag;
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (store.state.isLogged && to.name !== 'Logout') {
        next(vm.$i18n.t('urlUser'));
      }
    });
  },
  metaInfo() {
    return {
      title: this.$i18n.t('page.title'),
      meta: [
        {
          name: 'description',
          content: this.$i18n.t('page.description')
        },
        {
          name: 'apple-itunes-app',
          content: 'app-id=573568924'
        },
        {
          name: 'keywords',
          content: this.$i18n.t('page.keywords')
        },
        {
          property: 'twitter:title',
          content: this.$i18n.t('meta.twitter.title')
        },
        {
          property: 'twitter:card',
          content: 'photo'
        },
        {
          property: 'twitter:site',
          content: this.twitterHashtag
        },
        {
          property: 'twitter:image',
          content: utilService.getSharedLogo()
        },
        {
          property: 'twitter:url',
          content: window.location.href
        },
        {
          property: 'og:title',
          content: this.$i18n.t('meta.og.title')
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          property: 'og:site_name',
          content: 'wesmartPark'
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:description',
          content: this.$i18n.t('meta.og.description')
        },
        {
          property: 'og:image',
          content: utilService.getSharedLogo()
        },
        {
          property: 'og:image:secure_url',
          content: utilService.getSharedLogo()
        },
        {
          property: 'og:image:alt',
          content: this.$i18n.t('meta.og.image')
        },
        {
          property: 'og:image:width',
          content: '1200'
        },
        {
          property: 'og:image:height',
          content: '586'
        },
        {
          property: 'og:image:type',
          content: 'image/jpeg'
        }
      ]
    };
  },
  created() {},
  destroyed() {},
  methods: {
    onWaypoint({ going, el }) {
      if (going === this.$waypointMap.GOING_IN) {
        EventBus.$emit(keys.eventShowToolbar, { offset: el.offsetTop });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bcn-background-image {
  background: url('/image/public/bg/background_bcn.jpg');
}
.mad-background-image {
  background: url('/image/public/bg/background_mad.jpg');
}
.scl-background-image {
  background: url('/image/public/bg/background_scl.jpg');
}
.lim-background-image {
  background: url('/image/public/bg/background_lim.jpg');
}
.bue-background-image {
  background: url('/image/public/bg/background_bue.jpg');
}
.lle-background-image {
  background: url('/image/public/bg/background_lle.jpg');
}
</style>

<style lang="scss">
#landing-section .v-card {
  margin-top: -10%;
}

#step-section {
  background-color: #5ea4c8;
  width: 100%;
  font-size: 1.3em;
  font-weight: bold;
}

#step-section .v-card__media__content {
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

#section-description .v-list__tile__sub-title {
  font-size: 1.5em;
}

#section-review {
  background-color: #fafafa;
}

#section-review .v-carousel {
  // height: 250px;
  box-shadow: none;
}

#section-review .v-btn {
  color: #6f6f6f;
}

#section-review .v-card {
  background-color: #fafafa;
  width: 90%;
  margin-left: 5%;
}

#section-review .v-card .v-card__title,
#section-review .v-card .v-card__text {
  color: #6f6f6f;
  font-size: 1.7em;
}

#section-review .v-card .v-card__actions {
  height: 30px;
}

#section-video {
  background-image: linear-gradient(
      to right,
      rgb(94, 164, 200),
      rgb(103, 232, 224)
    ),
    url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGP6zwAAAgcBApocMXEAAAAASUVORK5CYII=);
  background-position: center center;
}

.video-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: auto;
  overflow: hidden;
}

.video-container iframe,
.video-container object,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.v-responsive__sizer {
  padding-bottom: 0px !important;
}

#home .v-carousel .v-image.v-carousel__item {
  height: auto !important;
}

#home .v-carousel .v-window__container {
  height: auto !important;
}
</style>

<style lang="scss" scoped>
#landing-section {
  height: 100vh;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
}
.xs #landing-section {
  height: calc(100vh - 87px);
}
.xl #landing-section {
  height: calc(100vh - 88px);
}

#landing-section #slogan {
  font-weight: bold;
}
.xs #landing-section #slogan {
  font-size: 6vh;
  line-height: 6vh;
}
.sm #landing-section #slogan {
  font-size: 8vh;
  line-height: 8vh;
}
.md #landing-section #slogan {
  font-size: 8vh;
  line-height: 8vh;
}
.lg #landing-section #slogan {
  font-size: 8vh;
  line-height: 8vh;
}

#landing-section #landing-section-bottom {
  position: absolute;
  bottom: 0;
  width: 100%;
}

#landing-section #landing-section-bottom #download-app {
  // background-color: #da9500;
  width: 100%;
  padding: 2px;
  font-size: 1.4em;
}

.xs #landing-section #landing-section-bottom #download-app,
.sm #landing-section #landing-section-bottom #download-app {
  font-size: 2vh;
}

/* For width smaller than 768px: */
.contact {
  background: url(/image/parking-inside_screen_min_w_768.png) no-repeat;
  background-size: cover !important;
  background-repeat: no-repeat;
  background-attachment: fixed !important;
  padding-bottom: 4em;
  padding-top: 4em;
}

/* For width 768px and larger: */
@media only screen and (min-width: 768px) {
  .contact {
    background: url(/image/parking-inside.jpg) no-repeat;
    background-size: cover !important;
    background-repeat: no-repeat;
    background-attachment: fixed !important;
    padding-bottom: 4em;
    padding-top: 4em;
  }
}

.contact .v-container {
  background-color: rgba(0, 0, 0, 0.75);
  padding-top: 50px;
  padding-bottom: 50px;
}

.contact a,
.contact-bis a {
  height: 70px;
}

.contact a b,
.contact-bis a b {
  font-size: 2.3em;
}
</style>
